import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const CTASection = ({ onOpenContactForm, heading, buttonText, variant = 'green' }) => {
  const section = useScrollAnimation({ threshold: 0.2 });
  return (
    <section data-testid="cta-section" ref={section.ref} className="relative overflow-hidden bg-[#093336]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1634976276568-9ea10353a8cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbHV4dXJ5JTIwYWJzdHJhY3QlMjBzbW9rZSUyMHNpbGslMjB0ZXh0dXJlfGVufDB8fHxncmVlbnwxNzc2MjkyOTMwfDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#093336]/40 via-transparent to-[#093336]/40" />
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 md:py-28 relative z-10">
        <div className={`max-w-3xl mx-auto text-center scroll-fade-up ${section.isVisible ? 'scroll-visible' : ''}`}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] leading-tight mb-8" style={{ fontFamily: "'Outfit', sans-serif" }}>{heading}</h2>
          <Button data-testid="cta-section-button" onClick={onOpenContactForm}
            className={`font-semibold px-10 h-13 text-base rounded-full transition-all duration-300 hover:-translate-y-1 ${
              variant === 'green' ? 'bg-[#A5BF23] hover:bg-[#8A9F1D] text-[#041B1C] hover:shadow-[0_8px_32px_rgba(165,191,35,0.3)]' : 'bg-[#F0F4F4] text-[#041B1C] hover:bg-white hover:shadow-[0_8px_32px_rgba(255,255,255,0.1)]'
            }`}>
            {buttonText} <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
